import { useEffect, useState, useCallback } from "react";
import { api } from "./api";

/**
 * Lightweight stats hook — fetches GET /api/me/stats once per mount and
 * exposes a refresh() caller used right after a session-ping. Returns null
 * until the first fetch resolves so consumers can skip rendering cleanly.
 */
export default function useStats() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/me/stats");
      setStats(data);
    } catch {
      /* non-fatal */
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);
  return { stats, loading, refresh, setStats };
}
